<template>
  <div style="width: 250px">
    <v-simple-table dense style="background: none">
      <thead>
        <tr>
          <th class="text-left">Názov</th>
          <th class="text-left">Verzia</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Filip.Client</td>
          <td>{{ client }}</td>
        </tr>
        <tr v-for="(item, index) in api" :key="index">
          <td>{{ item.assemblyName }}</td>
          <td>{{ item.version }}</td>
        </tr>
      </tbody>
    </v-simple-table>
    <p class="mt-2" v-if="errorMessages.length > 0">{{ errorMessages }}</p>
  </div>
</template>
<script>
import protectedAxios from '../auth/axios.js';

export default {
  data() {
    return {
      client: process.env.VUE_APP_VERSION,
      api: [],
      errorMessages: '',
    };
  },
  mounted() {
    return protectedAxios
      .get(`about/version/`)
      .then(res => {
        this.api = res.data;
      })
      .catch(e => {
        console.error(e);
        this.errorMessages = 'Chyba pri načítaní verzie api.';
      });
  },
};
</script>
